import { render } from "./AppointmentSlot.vue?vue&type=template&id=60afaaa1&scoped=true"
import script from "./AppointmentSlot.vue?vue&type=script&lang=js"
export * from "./AppointmentSlot.vue?vue&type=script&lang=js"

import "./AppointmentSlot.vue?vue&type=style&index=0&id=60afaaa1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60afaaa1"]])

export default __exports__